import { ShareMessageFragment } from "~/__generated__/graphql"
import { ChatShareMessage } from "./message/chat-share-message"
import { AppText } from "~/ui/app-text"

interface HighlightedMessageProps {
  message: ShareMessageFragment
  compact?: boolean
  showHeader?: boolean
}

export const HighlightedMessage = ({
  message,
  compact = false,
  showHeader = true,
}: HighlightedMessageProps) => {
  return (
    <div className="flex w-full flex-col gap-2">
      {showHeader && (
        <AppText variant="hairline-1" className="text-center text-base-white opacity-60">
          A message was shared with you
        </AppText>
      )}
      <div className="rounded-[24px] bg-neutral-100 p-4">
        <ChatShareMessage message={message} compact={compact} />
      </div>
    </div>
  )
}
